import { render } from "./A&PCover.vue?vue&type=template&id=615f1a2b&scoped=true"
import script from "./A&PCover.vue?vue&type=script&lang=js"
export * from "./A&PCover.vue?vue&type=script&lang=js"

import "./A&PCover.vue?vue&type=style&index=0&id=615f1a2b&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615f1a2b"]])

export default __exports__